export default __webpack_public_path__ + "static/media/cedar.f008679a.webp";